export const adminProfile = (state = INITIAL_STATE, { type }) => {
  switch (type) {
    default:
      return state
  }
}

const INITIAL_STATE = {}
